import { queryOptions } from '@tanstack/react-query';

import { getAwardQuery, getAwardsQuery } from './shared';

export const getAwardQueryOptions = (id: string) => queryOptions(getAwardQuery(id));
export const getAwardsQueryOptions = () => queryOptions(getAwardsQuery());
